import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px', // space between logo and title
          marginBottom: '25px',
        }}>
          <img 
            src={`${process.env.PUBLIC_URL}/ML-Logo.png`}
            alt="Miller & Long Logo" 
            style={{
              width: '4.188rem',
              height: '4.188rem',
              objectFit: 'contain',
              filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.3))',
            }} 
          />
          <h2>Baby Blue Concrete</h2> 
      </div>
      <nav>
        <ul>
          <li>
            <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/projects" className={({ isActive }) => isActive ? 'active' : ''}>
              Projects
            </NavLink>
          </li>
          <li>
            <NavLink to="/logs/new" className={({ isActive }) => isActive ? 'active' : ''}>
              New Production Log
            </NavLink>
          </li>
          <li>
            <NavLink to="/analytics/estimator" className={({ isActive }) => isActive ? 'active' : ''}>
              Job Estimator
            </NavLink>
          </li>
          <li>
            <NavLink to="/logs" className={({ isActive }) => isActive ? 'active' : ''}>
              View Logs
            </NavLink>
          </li>
          <li>
            <NavLink to="/analytics/rates" className={({ isActive }) => isActive ? 'active' : ''}>
              Production Rates
            </NavLink>
          </li>
          <li>
            <NavLink to="/analytics/formwork" className={({ isActive }) => isActive ? 'active' : ''}>
              Formwork Efficiency
            </NavLink>
          </li>
          <li>
            <NavLink to="/analytics/equipment" className={({ isActive }) => isActive ? 'active' : ''}>
              Equipment Utilization
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;